export default __webpack_public_path__ + "static/nextGenerationMechanicalHotPip-74e5934092adb7efcc0be2563067ac99.png";